import React, { useState, useMemo, useEffect, useRef } from "react";
import { Grid, Typography, Paper } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useCookies } from "react-cookie";


import PlanInputs from "../../pages/plan-inputs";
import PresentationNavBar from "../presentation-navbar";
import { FancyButtonNavBar } from "../presentation-fancy-button-navbar";
import { currencyFormatNoDecimals } from "../../shared/shared";
import { firstLetterUpperCase } from "../../shared/first-letter-upper";
import { getCurrentYear } from "../../shared/shared";

const PresentationAssumptions = (props) => {
  const [isCalculated, setIsCalculated] = useState(false);
  const [state, setState] = useState({
    showFutureAdjustments: false,
    goals: [{
      id: null,
      editIndex: 0,
      inEdit: true,
      amount: 0,
      endYear: getCurrentYear(),
      incomeType: "PENSION",
      frequency: "MONTHLY",
      startYear: getCurrentYear(),
    },],
    ShowButtonCalculatePlanInput: true,
    taxFreeAccounts: 0,
    nqAccounts: 0,
    preTaxAssets: 0,
    monthlyRetirementBudget: 0,
  })

  const client = useSelector((state) => state.dataStore.get("currentClient"));

  const planCashFlow = useSelector((state) => state.dataStore.get("currentPlanCashFlow"));
  const futurePlanCashFlow = useSelector((state) => state.dataStore.get("currentFuturePlanCashFlow"));

  const ASSUMPTIONS = 0;
  const FUTURE = 1;

  const [presentationPage, setPresentationPage] = useState(0);
  const [activeLink, setActiveLink] = useState({
    [ASSUMPTIONS]: true,
    [FUTURE]: false
  });

  const handleActiveLink = (idx) => {
    setActiveLink({
      [ASSUMPTIONS]: false,
      [FUTURE]: false,
      [idx]: true
    })
    setPresentationPage(idx);
  }

  const currentPlanCashFlowData = useMemo(() => {
    return planCashFlow?.toJS();
  });

  const futurePlanCashFlowData = useMemo(() => {
    return futurePlanCashFlow?.toJS();
  });

  useEffect(() => {
      console.log("Is Calculated? ", isCalculated);
      if (isCalculated) props.updateDataAfterCalculation();
  }, [isCalculated])

  useEffect(() => {
      console.log("Calculations Performed...");

    if (presentationPage === ASSUMPTIONS) {
      setState(
        (values) =>
        ({
          ...values,
          showFutureAdjustments: true,
          ShowButtonCalculatePlanInput: true,
          monthlyRetirementBudget: currencyFormatNoDecimals(parseInt(currentPlanCashFlowData?.assumptions.monthlyRetirementBudget || 0)),
          taxFreeAccounts: currencyFormatNoDecimals(parseInt(currentPlanCashFlowData?.assumptions.taxFreeAccounts || 0)),
          nqAccounts: currencyFormatNoDecimals(parseInt(currentPlanCashFlowData?.assumptions.nonQualifiedAssets || 0)),
          preTaxAssets: currencyFormatNoDecimals(parseInt(currentPlanCashFlowData?.assumptions.preTaxAssets || 0))
        }))
    } else if (presentationPage === FUTURE) {
      setState(
        (values) =>
        ({
          ...values,
          showFutureAdjustments: false,
          ShowButtonCalculatePlanInput: false,
          monthlyRetirementBudget: currencyFormatNoDecimals(parseInt(futurePlanCashFlowData?.assumptions?.monthlyRetirementBudget || 0)),
          taxFreeAccounts: currencyFormatNoDecimals(parseInt(futurePlanCashFlowData?.assumptions?.taxFreeAccounts || 0)),
          nqAccounts: currencyFormatNoDecimals(parseInt(futurePlanCashFlowData?.assumptions?.nonQualifiedAssets || 0)),
          preTaxAssets: currencyFormatNoDecimals(parseInt(futurePlanCashFlowData?.assumptions?.preTaxAssets || 0))
        }))
    }
  }, [presentationPage, isCalculated]);


  return (<PresentationNavBar>
    {(<>
      <FancyButtonNavBar
        activeLink={activeLink[ASSUMPTIONS]}
        onClick={() => handleActiveLink(ASSUMPTIONS)}
        text={"Current Plan Assumptions"}
        shadow={false}
      />
      <FancyButtonNavBar
        activeLink={activeLink[FUTURE]}
        onClick={() => {
          handleActiveLink(FUTURE);
        }}
        text={"Future Plan Assumptions"}
      />
    </>)}

    {(
      <Grid container mt={7} >
        <Grid container mb={3} justifyContent={"center"} alignItems={"center"} >
          <Typography component={"h2"} variant={"h3"} color={"#007bef"} > {"View/Edit "}{presentationPage == ASSUMPTIONS ? "Assumptions" : "Future"}  </Typography>
        </Grid>
        <Grid className={"presentation-assumptions"} container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={11} className="header-div">
              <Grid container>
                <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Typography component={"h1"}>
                    {firstLetterUpperCase(client.getIn(['client', 'firstName']))}
                    {" "}
                    {firstLetterUpperCase(client.getIn(['client', 'lastName']))}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <Paper elevation={0}>
                        <Typography component={"h4"}>
                          Non-Qualified Assets
                        </Typography>
                        <Typography component={"span"}>{state.nqAccounts}</Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={4}>
                      <Paper elevation={0}>
                        <Typography component={"h4"}>
                          Pre-Tax Assets
                        </Typography>
                        <Typography component={"span"}>{state.preTaxAssets}</Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={4}>
                      <Paper elevation={0}>
                        <Typography component={"h4"}>
                          Tax Free Accounts
                        </Typography>
                        <Typography component={"span"}>{state.taxFreeAccounts}</Typography>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} mb={5}>
                  <hr />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <div className="plan-inputs">
            <PlanInputs
              hideButtonPublishSave={true}
              hideButtonCalculatedPlan={state.ShowButtonCalculatePlanInput}
              hideControls={true}
              hideFutureAdjustments={state.showFutureAdjustments}
              hideCurrentPlan={false}  //not show button save
              clientId={client.getIn(['client', 'id'])}
              clientFpid={client.getIn(['advisorId'])}
              calculatePlan={presentationPage}
              setIsCalculated={setIsCalculated}
              setGoals={setState}
              currentPlanReadyOnly={!state.showFutureAdjustments}
              isOutput={true}
              isPageUpdated={props.isPageUpdated}
            />
          </div>
        </Grid>
      </Grid>
    )}
  </PresentationNavBar>);
};

export default PresentationAssumptions;

